var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "row",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.createChannel()
        }
      }
    },
    [
      _c("div", { staticClass: "medium-8 columns" }, [
        _c("label", { class: { error: _vm.$v.inboxName.$error } }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("INBOX_MGMT.ADD.SMS.BANDWIDTH.INBOX_NAME.LABEL")) +
              "\n      "
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.inboxName,
                expression: "inboxName",
                modifiers: { trim: true }
              }
            ],
            attrs: {
              type: "text",
              placeholder: _vm.$t(
                "INBOX_MGMT.ADD.SMS.BANDWIDTH.INBOX_NAME.PLACEHOLDER"
              )
            },
            domProps: { value: _vm.inboxName },
            on: {
              blur: [
                _vm.$v.inboxName.$touch,
                function($event) {
                  return _vm.$forceUpdate()
                }
              ],
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.inboxName = $event.target.value.trim()
              }
            }
          }),
          _vm._v(" "),
          _vm.$v.inboxName.$error
            ? _c("span", { staticClass: "message" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("INBOX_MGMT.ADD.SMS.BANDWIDTH.INBOX_NAME.ERROR")
                  )
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "medium-8 columns" }, [
        _c("label", { class: { error: _vm.$v.phoneNumber.$error } }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("INBOX_MGMT.ADD.SMS.BANDWIDTH.PHONE_NUMBER.LABEL")
              ) +
              "\n      "
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.phoneNumber,
                expression: "phoneNumber",
                modifiers: { trim: true }
              }
            ],
            attrs: {
              type: "text",
              placeholder: _vm.$t(
                "INBOX_MGMT.ADD.SMS.BANDWIDTH.PHONE_NUMBER.PLACEHOLDER"
              )
            },
            domProps: { value: _vm.phoneNumber },
            on: {
              blur: [
                _vm.$v.phoneNumber.$touch,
                function($event) {
                  return _vm.$forceUpdate()
                }
              ],
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.phoneNumber = $event.target.value.trim()
              }
            }
          }),
          _vm._v(" "),
          _vm.$v.phoneNumber.$error
            ? _c("span", { staticClass: "message" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("INBOX_MGMT.ADD.SMS.BANDWIDTH.PHONE_NUMBER.ERROR")
                  )
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "medium-8 columns" }, [
        _c("label", { class: { error: _vm.$v.accountId.$error } }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("INBOX_MGMT.ADD.SMS.BANDWIDTH.ACCOUNT_ID.LABEL")) +
              "\n      "
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.accountId,
                expression: "accountId",
                modifiers: { trim: true }
              }
            ],
            attrs: {
              type: "text",
              placeholder: _vm.$t(
                "INBOX_MGMT.ADD.SMS.BANDWIDTH.ACCOUNT_ID.PLACEHOLDER"
              )
            },
            domProps: { value: _vm.accountId },
            on: {
              blur: [
                _vm.$v.accountId.$touch,
                function($event) {
                  return _vm.$forceUpdate()
                }
              ],
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.accountId = $event.target.value.trim()
              }
            }
          }),
          _vm._v(" "),
          _vm.$v.accountId.$error
            ? _c("span", { staticClass: "message" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("INBOX_MGMT.ADD.SMS.BANDWIDTH.ACCOUNT_ID.ERROR")
                  )
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "medium-8 columns" }, [
        _c("label", { class: { error: _vm.$v.applicationId.$error } }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("INBOX_MGMT.ADD.SMS.BANDWIDTH.APPLICATION_ID.LABEL")
              ) +
              "\n      "
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.applicationId,
                expression: "applicationId",
                modifiers: { trim: true }
              }
            ],
            attrs: {
              type: "text",
              placeholder: _vm.$t(
                "INBOX_MGMT.ADD.SMS.BANDWIDTH.APPLICATION_ID.PLACEHOLDER"
              )
            },
            domProps: { value: _vm.applicationId },
            on: {
              blur: [
                _vm.$v.applicationId.$touch,
                function($event) {
                  return _vm.$forceUpdate()
                }
              ],
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.applicationId = $event.target.value.trim()
              }
            }
          }),
          _vm._v(" "),
          _vm.$v.applicationId.$error
            ? _c("span", { staticClass: "message" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("INBOX_MGMT.ADD.SMS.BANDWIDTH.APPLICATION_ID.ERROR")
                  )
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "medium-8 columns" }, [
        _c("label", { class: { error: _vm.$v.apiKey.$error } }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("INBOX_MGMT.ADD.SMS.BANDWIDTH.API_KEY.LABEL")) +
              "\n      "
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.apiKey,
                expression: "apiKey",
                modifiers: { trim: true }
              }
            ],
            attrs: {
              type: "text",
              placeholder: _vm.$t(
                "INBOX_MGMT.ADD.SMS.BANDWIDTH.API_KEY.PLACEHOLDER"
              )
            },
            domProps: { value: _vm.apiKey },
            on: {
              blur: [
                _vm.$v.apiKey.$touch,
                function($event) {
                  return _vm.$forceUpdate()
                }
              ],
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.apiKey = $event.target.value.trim()
              }
            }
          }),
          _vm._v(" "),
          _vm.$v.apiKey.$error
            ? _c("span", { staticClass: "message" }, [
                _vm._v(
                  _vm._s(_vm.$t("INBOX_MGMT.ADD.SMS.BANDWIDTH.API_KEY.ERROR"))
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "medium-8 columns" }, [
        _c("label", { class: { error: _vm.$v.apiSecret.$error } }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("INBOX_MGMT.ADD.SMS.BANDWIDTH.API_SECRET.LABEL")) +
              "\n      "
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.apiSecret,
                expression: "apiSecret",
                modifiers: { trim: true }
              }
            ],
            attrs: {
              type: "text",
              placeholder: _vm.$t(
                "INBOX_MGMT.ADD.SMS.BANDWIDTH.API_SECRET.PLACEHOLDER"
              )
            },
            domProps: { value: _vm.apiSecret },
            on: {
              blur: [
                _vm.$v.apiSecret.$touch,
                function($event) {
                  return _vm.$forceUpdate()
                }
              ],
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.apiSecret = $event.target.value.trim()
              }
            }
          }),
          _vm._v(" "),
          _vm.$v.apiSecret.$error
            ? _c("span", { staticClass: "message" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("INBOX_MGMT.ADD.SMS.BANDWIDTH.API_SECRET.ERROR")
                  )
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "medium-12 columns" },
        [
          _c("woot-submit-button", {
            attrs: {
              loading: _vm.uiFlags.isCreating,
              "button-text": _vm.$t(
                "INBOX_MGMT.ADD.SMS.BANDWIDTH.SUBMIT_BUTTON"
              )
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }